'use strict'
import _ from "lodash";
import ViewBase from '../view-base.view';
import loginModel from '../../models/login.model'
import vocModel from '../../models/voc/voc.model';

export default function VocImageGalleryView() {
    ViewBase.call(this);

    let currentCountry;

    let _files = [];
    let _selectedFileId;

    let _downloadSingleFile = (fileMasterId, fileName) => {
        this.showLoading();

        vocModel.downloadSingleFileAttachment(            
            (result) => {
                this.hideLoading();
            },
            (error) => {
                this.hideLoading();
                this.handleError(error);
            },
            fileMasterId,
            fileName
        );
    };

    return {
        oninit: (vnode) => {
            
            if (vnode.attrs.files && vnode.attrs.selectedFileId) {
                _files = vnode.attrs.files;
                _selectedFileId = vnode.attrs.selectedFileId;
            }
            
            currentCountry = loginModel.credentials.country;
        },
        onupdate: (vnode) => {
            if (loginModel.credentials.country !== currentCountry) {
                
                currentCountry = loginModel.credentials.country;
            }
        }, 
        view: ({ attrs }) => {

            return m('#imageGallery.carousel.slide',
                m('.carousel-inner', 
                    _files.map(function (file, index) {
                                            
                        return m('.carousel-item' + (_selectedFileId == file.fileMasterId ? '.active' : ''), { "style": "height: 500px;" }, 
                            
                            file.photoFlag == 'Y' && m('img.d-block', { src: file.fileContent, "style": "height: 100%; max-height: 100%; max-width: 100%; margin: auto;" }),
                            
                            file.photoFlag != 'Y' && m('.fs-1.text-center.align-middle', { style: 'margin-top: 120px;' },
                                m("i", { "class": "bi bi-file-earmark", style: "margin-right: 0 !important;" }),
                                m("div", { "style": "text-overflow: ellipsis; overflow: hidden; white-space: nowrap; width: 100%; padding: 0 6px;" },
                                    file.fileName
                                ),
                                m("button.btn.btn-primary[type='button']", { 
                                    style: 'margin-top: 10px;', 
                                    onclick: () => { _downloadSingleFile(file.fileMasterId, file.fileName); } 
                                }, "Download File")
                            )
                        );
                    })
                ),
                m('button[type="button"].carousel-control-prev', { "data-bs-target": "#imageGallery", "data-bs-slide": "prev" },
                    m('span.fs-1.text-primary', { "aria-hidden": "true" }, m("i", { "class": "bi bi-arrow-left-circle-fill" })),
                    m('span.visually-hidden', "Previous")
                ),
                m('button[type="button"].carousel-control-next', { "data-bs-target": "#imageGallery", "data-bs-slide": "next" },
                    m('span.fs-1.text-primary', { "aria-hidden": "true" }, m("i", { "class": "bi bi-arrow-right-circle-fill" })),
                    m('span.visually-hidden', "Next")
                )
            );
        
        }
    }
}